import { createBrowserRouter } from 'react-router-dom';
import { GetReport } from '../screens/GetReport';
import { Landing } from '../screens/Landing';
import { NotFound } from '../screens/NotFound';
import { Report } from '../screens/Report';
import { Review } from '../screens/Review';
import { Select } from '../screens/Select';
import { SharedReport } from '../screens/SharedReport';
import { AppLayout } from './AppLayout';

export const router = createBrowserRouter([
  {
    element: <AppLayout />,
    children: [
      { path: '/', element: <Landing /> },
      { path: '/review', element: <Review /> },
      { path: '/get-report', element: <GetReport /> },
      { path: '/report', element: <Report /> },
      { path: '/report/:reviewId', element: <SharedReport /> },
      // Bare-path WAR entry (e.g. /databricks) -> pillar selection. Ranked below
      // the static routes above, so "review"/"report"/etc. never match here.
      { path: '/:focus', element: <Select /> },
      { path: '*', element: <NotFound /> },
    ],
  },
]);
